import React from 'react';
import { Button } from "react-bootstrap";

const Row = ({ id, date, affid, subid, country, impressions, onRemove }) => {
    return (
        <tr>
            <td>{date}</td>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            <td>{impressions}</td>
            <td>
                <Button bsStyle="danger" onClick={() => onRemove(id)}>Remove</Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBlock/components/Table/components/Row/index.js